import React from 'react';
import "../Styles/Combo.css"

export default function Combo() {
  return <div>
                <div style={{ height: "108px" }}></div>

      <div className="container">
          <div className="container-items">
              <img src="Images/Slider2.JPG" alt="" />
              <img src="Images/Slider1.JPG" alt="" />
              <img src="Images/Slider3.JPG" alt="" />


          </div>
      </div>
  </div>;
}
